// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__MEAwe","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1OZYm"};